import PracticeHero from "@/pages/PracticeHero";
import { ProcessCycle } from "@/components/ProcessCycle";
import { usePageTitle } from "@/lib/usePageTitle";

export default function Advisory() {
  usePageTitle("Practice | Mentheris", "How Mentheris brings research into practice: organisational diagnosis, co-creation and experimentation with organisations and research ecosystems.");
  return (
    <main data-testid="advisory-page">
      <PracticeHero />
      <ProcessCycle />
    </main>
  );
}
